var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFaceHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "80px",
    viewBox: "0 0 70 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M40.365,76.165c-3.299-1.49-7.079-1.49-10.378,0c0-1.934,0-3.867,0-5.801c3.299-1.49,7.079-1.49,10.378,0 C40.365,72.298,40.365,74.231,40.365,76.165z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.21,
    y1: 38.326,
    x2: 35.21,
    y2: 18.407
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 35.21,
    cy: 17.633,
    r: 3.288
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.253,53.462c0,2.596-2.124,4.719-4.719,4.719h-3.325c-2.596,0-4.719-2.123-4.719-4.719v-6.806 c0-2.596,2.124-4.72,4.719-4.72h3.325c2.596,0,4.719,2.124,4.719,4.72V53.462z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.253,53.462c0,2.596-2.124,4.719-4.719,4.719h-3.325c-2.596,0-4.719-2.123-4.719-4.719v-6.806c0-2.596,2.124-4.72,4.719-4.72 h3.325c2.596,0,4.719,2.124,4.719,4.72V53.462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60.93,53.462c0,2.596-2.124,4.719-4.719,4.719h-3.326c-2.595,0-4.719-2.123-4.719-4.719v-6.806 c0-2.596,2.124-4.72,4.719-4.72h3.326c2.595,0,4.719,2.124,4.719,4.72V53.462z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M60.93,53.462c0,2.596-2.124,4.719-4.719,4.719h-3.326c-2.595,0-4.719-2.123-4.719-4.719v-6.806c0-2.596,2.124-4.72,4.719-4.72 h3.326c2.595,0,4.719,2.124,4.719,4.72V53.462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.945,65.204c0,2.412-1.974,4.387-4.386,4.387H19.86c-2.412,0-4.385-1.975-4.385-4.387V34.507 c0-2.412,1.974-4.386,4.385-4.386h30.699c2.412,0,4.386,1.974,4.386,4.386V65.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M54.945,65.204c0,2.412-1.974,4.387-4.386,4.387H19.86c-2.412,0-4.385-1.975-4.385-4.387V34.507c0-2.412,1.974-4.386,4.385-4.386 h30.699c2.412,0,4.386,1.974,4.386,4.386V65.204z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M26.602,53.997c0.696,4.129,4.28,7.277,8.608,7.277c4.329,0,7.912-3.148,8.608-7.277H26.602z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M29.391,47.087c-0.23-1.363-1.412-2.4-2.839-2.4s-2.609,1.037-2.839,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M46.708,47.087c-0.229-1.363-1.411-2.4-2.839-2.4s-2.609,1.037-2.839,2.4"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.184,
    y1: 17.472,
    x2: 22.156,
    y2: 17.472
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 48.264,
    y1: 17.472,
    x2: 43.236,
    y2: 17.472
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 28.259,
    y1: 13.459,
    x2: 23.905,
    y2: 10.946
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 46.515,
    y1: 24,
    x2: 42.161,
    y2: 21.486
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 28.26,
    y1: 21.486,
    x2: 23.906,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.7018,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 46.516,
    y1: 10.946,
    x2: 42.161,
    y2: 13.459
  }), /*#__PURE__*/React.createElement("image", {
    width: 47,
    height: 165,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAACrCAYAAAAkVs86AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmRJREFUeNrs3c1qwkAUhuH8Cu3C Sm9Awfu/JEEvoFQXBUtaaaakom2smWRmzpnkHZAuGmGefN+JU7owT0ay8rFAUpuL18vVU/2jbPnV YbPbVpKQwhJgrs9aLsmkEykGAtSs4g7ioQPgUL8qlcNugTDrrZ6PD2lINhChZmVjQLQlUsaIuII0 aRRJpCsbQxpnSOxpXCYSdRpJ7JsHAgQIECBAgAABAgQIECBAgAABAgQIECBA7q35erkqxwBR8S8J qgUECBAgQIAAAaIfIn4CdgURPwFTLSBAgAABAsQxRPSY4hIiekyhWkCAAJk2ROyzxDVE7LOEagEB AiSuR7APiMgjmGoBASIDCf7k8gUJ/uSiWkCAyEGCPrl8QoI+uagWkEghwQbeNyTYwFMtIBFDggx8 CEiQgadaU4V4n5NQEO9zQrWmDPE6JyEhXueEak0d4m1OQkO8zQnVAuJpTiQgXuaEammrlxTEeb2o lrZ6SUKc1otqaauXNMRZvaiWtnppgDipF9XSVi8tkMH1olra6qUJMqhe2qrVOxVtkN6pMOza6qUR 0qteWqtlnYpWiHUqDLu2emmGWNVLe7U6p6Id0jmVGIa9Uyo/EBVfYDokle8vP3097E/Pi8Vjoveb j8t6f5XZZ5dqRZ3KOYHYU/mtjDaVq7vfpGIgM6XJ3Ezlz2aVV8zsadaGuRVVdBVrvesXFTs2b8y1 V+zmBs1F9etT6cyYvRzN/u5CIkjnKpXU5p3Nmcf0c96gpJe5wfvNblulfd59AbI+AHq4AS815D0N efsG3IB/U6khp7H8ya72XDVdyJcAAwDA331momQMsQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 15.4751 30.269)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 67,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABHCAYAAACJSS4oAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPdJREFUeNrs2UEKgzAQBdA4DXQ1 IL2Agvc/UqE9gS3ZdVUsBEqw0TFmBumfjSBGHn+iRm1cYQ1dz5Ljr/dbSPc1OwBYOCykkJMyYKrz pW3d+Hy84g5SBsTioiR2AHzqOw2yAKRpkBHAidtRCxBbQpYJxPOSIcAtzgktwE+EJiCXhBpg8x0T CCCA+G+EdOFaKwlGO4AAAggggAACiAMhgjkifsVDO4AA4nCIYI6Y+x+BOQEEEFaXKeWe82gHEFaT kxYWoUED49eshoeunzZsOidqp+Kl7wg1UhFfHTVS8VsGJakUJ+NLBs9gcsVVEJJnzUooyr7eAgwA hg9N7oWoP8YAAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 9.1382 41.875)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 23,
    height: 27,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAhCAYAAAAlK6DZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQhJREFUeNrsll0LgjAUhrelRt0k +QMK+v8/Kaj7IO0ywzoHJojo3PnQLurAGHO6Z++7D48x/5gxbKjzdDg6qFLfbM7XS60BTSaAGyg7 /+gJ5aYBdZFA1XAEoIW+VB06oTDVUu7mGjgK6lUmSxwZR1Spsq6O+L6K/e4bNxIHKraYAxVbzLVX pJYLRWDOBUs2Ettm6e5l2SyFsmzWOKdksNblQAJ3oQ2Uegmw7f1P11AVQtU48Ucop+rbK1XbKi5C qlfdxr0qm32eIzTr9zECv89wPBx3FLoUeHD3+rUoFaxG0BvKlpJst1ed7STdMaBXu6lAQEXK8Afg ZmQCkyAyNDABEwv6zfgIMADgwEh+JLiW0QAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 31.8296 14.6265)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.4377,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 40.365,
    y1: 70.364,
    x2: 40.365,
    y2: 76.165
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.4377,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.987,
    y1: 76.165,
    x2: 29.987,
    y2: 70.364
  }), /*#__PURE__*/React.createElement("image", {
    width: 44,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIZJREFUeNrs2LENgCAQRmHOXJzA XhP3H8lEex3ATgagADwUyPsbK8z7GgqcY3VNcg+u8zL5z2jcc23HfheFFAo3w0ml8ckoaSA+CiQN IoKgoZdbCwgQIECAAAECBAgQIECAAOkMopYPALmzePTQr6ND8/883+L0r/gUXAxKa4q3QrEa9ggw AMfcN9y180V7AAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 29.9868 69.2471)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFaceHappy);
export default __webpack_public_path__ + "static/media/ai-face-happy.b0b2c4307be085638cbd44fd33b434f2.svg";
export { ForwardRef as ReactComponent };